"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PBTError = exports.ErrorCodesPipelineBuildTransaction = void 0;
const error_1 = require("../../../../stellar-plus/error");
var ErrorCodesPipelineBuildTransaction;
(function (ErrorCodesPipelineBuildTransaction) {
    // PBT0 General
    ErrorCodesPipelineBuildTransaction["PBT001"] = "PBT001";
    ErrorCodesPipelineBuildTransaction["PBT002"] = "PBT002";
    ErrorCodesPipelineBuildTransaction["PBT003"] = "PBT003";
    ErrorCodesPipelineBuildTransaction["PBT004"] = "PBT004";
    ErrorCodesPipelineBuildTransaction["PBT005"] = "PBT005";
})(ErrorCodesPipelineBuildTransaction || (exports.ErrorCodesPipelineBuildTransaction = ErrorCodesPipelineBuildTransaction = {}));
const couldntLoadAccount = (error, conveyorBeltErrorMeta) => {
    return new error_1.StellarPlusError({
        code: ErrorCodesPipelineBuildTransaction.PBT001,
        message: 'Could not load account!',
        source: 'PipelineBuildTransaction',
        details: "An issue occurred while loading the account's data. Refer to the meta section for more details.",
        meta: {
            error,
            conveyorBeltErrorMeta,
        },
    });
};
const couldntCreateTransactionBuilder = (error, conveyorBeltErrorMeta) => {
    return new error_1.StellarPlusError({
        code: ErrorCodesPipelineBuildTransaction.PBT002,
        message: 'Could not create transaction builder!',
        source: 'PipelineBuildTransaction',
        details: 'An issue occurred while creating the transaction builder. Refer to the meta section for more details.',
        meta: {
            error,
            conveyorBeltErrorMeta,
        },
    });
};
const couldntAddOperations = (error, conveyorBeltErrorMeta) => {
    return new error_1.StellarPlusError({
        code: ErrorCodesPipelineBuildTransaction.PBT003,
        message: 'Could not add operations!',
        source: 'PipelineBuildTransaction',
        details: 'An issue occurred while adding the operations to the transaction builder. Refer to the meta section for more details.',
        meta: {
            error,
            conveyorBeltErrorMeta,
        },
    });
};
const couldntBuildTransaction = (error, conveyorBeltErrorMeta) => {
    return new error_1.StellarPlusError({
        code: ErrorCodesPipelineBuildTransaction.PBT004,
        message: 'Could not build transaction!',
        source: 'PipelineBuildTransaction',
        details: "An issue occurred while building the transaction's envelope. Refer to the meta section for more details.",
        meta: {
            error,
            conveyorBeltErrorMeta,
        },
    });
};
const couldntSetSorobanData = (error, conveyorBeltErrorMeta) => {
    return new error_1.StellarPlusError({
        code: ErrorCodesPipelineBuildTransaction.PBT005,
        message: 'Could not set Soroban data!',
        source: 'PipelineBuildTransaction',
        details: 'An issue occurred while setting the Soroban data. Refer to the meta section for more details.',
        meta: {
            error,
            conveyorBeltErrorMeta,
        },
    });
};
exports.PBTError = {
    couldntLoadAccount,
    couldntCreateTransactionBuilder,
    couldntAddOperations,
    couldntBuildTransaction,
    couldntSetSorobanData,
};
